/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck

import {
    Radio as MuiRadio,
    Dialog as MuiDialog,
    DialogActions as MuiDialogActions,
    DialogContent as MuiDialogContent,
    DialogContentText as MuiDialogContentText,
    DialogTitle as MuiDialogTitle,
    Slider as MuiSlider,
    Tab as MuiTab,
    Tabs as MuiTabs,
    List as MuiList,
  Badge as MuiBadge,
  Autocomplete as MuiAutocomplete,
    IconButton as MuiIconButton,
    Checkbox as MuiCheckbox,
    FormControlLabel as MuiFormControlLabel,
    Chip as MuiChip,
    Select as MuiSelect,
    InputLabel as MuiInputLabel,
    OutlinedInput as MuiOutlinedInput,
    MenuItem as MuiMenuItem,
    FormHelperText as MuiFormHelperText,
    Tooltip as MuiTooltip,
    Alert as MuiAlert,
} from '@mui/material';

import { MuiLoadingButton } from '../lib/loading-button/loading-button.styles';
import { MuiButton } from '../lib/button/button.styles';
import { MuiTextField } from '../lib/text-field/text-field.styles';

import { ThemeOptions } from '@mui/material';
import { palette } from './palette';
import { textSizes, typography } from './typography';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import type {} from '@mui/lab/themeAugmentation';
import { colors } from '.';

export const baseThemeOptions: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1024,
      xl: 1200,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          font-size: ${textSizes.base}px;
          color: ${colors.grayDark3};
          overflow-x: hidden !important;
        }

        p {
          margin: unset;
        }

        input {
          font-family: inherit;
          color: inherit;
        }

        a {
          color: ${colors.secondaryDark1};
          text-decoration: underline;
        }

        a.noDecoration {
          text-decoration: none;
        }

        a:hover {
          color: ${colors.secondaryDark3};
          text-decoration: none;
        }

        /* Removed arrow from number input */
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;

        }

        input[type=number] {
          -moz-appearance: textfield;
        }
      `,
    },
    MuiButton,
    MuiTooltip,
    MuiTextField,
    MuiAutocomplete,
    MuiSelect,
    MuiInputLabel,
    MuiOutlinedInput,
    MuiMenuItem,
    MuiFormHelperText,
    MuiChip,
    MuiSlider,
    MuiAlert,
    MuiCheckbox,
    MuiFormControlLabel,
    MuiDialogTitle,
    MuiDialogContentText,
    MuiDialogContent,
    MuiDialogActions,
    MuiDialog,
    MuiLoadingButton,
    MuiBadge,
    MuiTab,
    MuiTabs,
    MuiList,
    MuiIconButton,
    MuiRadio,
  },
  typography,
  palette,
};
